var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{key:_vm.key,staticClass:"lms-switch",class:{ 'lms-switch--large': _vm.size === 'large', 'with-icon': _vm.withIcon },attrs:{"disabled":_vm.disabled,"name":"check-button","switch":""},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }